async function importRsaPublicKey(pem) {
  const base64 = pem
    .replace(/-----BEGIN PUBLIC KEY-----/, "")
    .replace(/-----END PUBLIC KEY-----/, "")
    .replace(/\s+/g, "");
  // 2. Base64 → binary DER
  const binaryDer = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
  const rsaPublicKey = crypto.subtle.importKey(
    "spki",
    binaryDer.buffer,
    {
      name: "RSA-OAEP",
      hash: "SHA-256",
    },
    false,
    ["encrypt"]
  );
  // 3. Import key
  return rsaPublicKey;
}

async function generateAesKey() {
  return crypto.subtle.generateKey({ name: "AES-GCM", length: 256 }, true, [
    "encrypt",
  ]);
}

export const encryptData = async (payload, aesKey) => {
  const iv = crypto.getRandomValues(new Uint8Array(12));
  const encoded = new TextEncoder().encode(JSON.stringify(payload));

  const encrypted = await crypto.subtle.encrypt(
    { name: "AES-GCM", iv },
    aesKey,
    encoded
  );

  return {
    iv: Buffer.from(iv).toString("base64"),
    data: Buffer.from(encrypted).toString("base64"),
  };
};

async function encryptAesKey(aesKey, rsaPublicKey) {
  const rawKey = await crypto.subtle.exportKey("raw", aesKey);

  const encryptedKey = await crypto.subtle.encrypt(
    { name: "RSA-OAEP" },
    rsaPublicKey,
    rawKey
  );

  return Buffer.from(encryptedKey).toString("base64");
}

export const generateEncryptData = async (payload) => {
  if (!payload) return {};
  const rsaPublicKey = await importRsaPublicKey(process.env.VUE_APP_PUBLIC_KEY);
  const aesKey = await generateAesKey();

  const encryptedPayload = await encryptData(payload, aesKey);
  const encryptedKey = await encryptAesKey(aesKey, rsaPublicKey);

  return {
    a: encryptedPayload.iv,
    b: encryptedKey,
    c: encryptedPayload.data,
  };
};



// WEBPACK FOOTER //
// ./src/helper/payloadHelper.js